
import { supabase } from '@/integrations/supabase/client';
import { ProcurementFinance, CreateProcurementFinanceInput } from '@/types/database.types';

export const createProcurementFinance = async (data: CreateProcurementFinanceInput): Promise<ProcurementFinance> => {
  const { data: result, error } = await supabase
    .from('procurement_finance')
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error('Error creating procurement finance:', error);
    throw error;
  }

  return result as ProcurementFinance;
};

export const getProcurementFinance = async (procurementId: string): Promise<ProcurementFinance | null> => {
  const { data, error } = await supabase
    .from('procurement_finance')
    .select('*')
    .eq('procurement_id', procurementId)
    .maybeSingle();

  if (error) {
    console.error('Error fetching procurement finance:', error);
    throw error;
  }

  return data as ProcurementFinance | null;
};

export const updateProcurementFinance = async (
  procurementId: string, 
  updates: Partial<CreateProcurementFinanceInput>
): Promise<ProcurementFinance> => {
  const { data, error } = await supabase
    .from('procurement_finance')
    .update(updates)
    .eq('procurement_id', procurementId)
    .select()
    .single();

  if (error) {
    console.error('Error updating procurement finance:', error);
    throw error;
  }

  return data as ProcurementFinance;
};
